"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRefundRequestMockData = exports.buildPastDueSubscriptionMockData = exports.buildRecurringPaymentSucceededAfterFailureMockData = exports.buildRecurringPaymentNeverMadeMockData = exports.buildFailedRecurringCardPaymentMockData = exports.buildFailedPadAchMockData = exports.buildFirstPaymentReceivedMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const buildFirstPaymentReceivedMockData = ({ locale = "en", subject = "Congratulations on your first payment!", firstName = "John", email = "john@your-organization.org", firstPaymentAmount = "$150.00", processingtime = "3", viewPayoutLink = "https://www.zeffy.com/en-US/o/bank/payouts", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    email,
    firstPaymentAmount,
    processingtime,
    viewPayoutLink,
});
exports.buildFirstPaymentReceivedMockData = buildFirstPaymentReceivedMockData;
const buildFailedPadAchMockData = ({ locale = "en", subject = "A bank transfer payment failed", firstName = "John", buyerName = "Jane Donor", buyerEmail = "jane.donor@example.com", amount = "$250.00", transactionDate = "March 14, 2026", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    buyerName,
    buyerEmail,
    amount,
    transactionDate,
});
exports.buildFailedPadAchMockData = buildFailedPadAchMockData;
const buildFailedRecurringCardPaymentMockData = ({ locale = "en", subject = "A recurring payment failed", firstName = "John", donorName = "Jane Donor", amount = "$50.00", programTypeLabelShort = "donation", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    donorName,
    amount,
    programTypeLabelShort,
});
exports.buildFailedRecurringCardPaymentMockData = buildFailedRecurringCardPaymentMockData;
const buildRecurringPaymentNeverMadeMockData = ({ locale = "en", subject = "A recurring payment was never made", firstName = "John", donorName = "Jane Donor", amount = "$50.00", programTypeLabelShort = "donation", email = "jane.donor@example.com", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    donorName,
    amount,
    programTypeLabelShort,
    email,
});
exports.buildRecurringPaymentNeverMadeMockData = buildRecurringPaymentNeverMadeMockData;
const buildRecurringPaymentSucceededAfterFailureMockData = ({ locale = "en", subject = "A recurring payment succeeded", firstName = "John", donorName = "Jane Donor", amount = "$50.00", programTypeLabelShort = "donation", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    donorName,
    amount,
    programTypeLabelShort,
});
exports.buildRecurringPaymentSucceededAfterFailureMockData = buildRecurringPaymentSucceededAfterFailureMockData;
const buildPastDueSubscriptionMockData = ({ locale = "en", subject = "A recurring payment is past due", orgFirstName = "John", donorFirstName = "Jane", donorLastName = "Donor", donorEmail = "jane.donor@example.com", referralLink = "https://www.zeffy.com/en-US/referral?code=MOCK1234", referralAmount = "$50", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    orgFirstName,
    donorFirstName,
    donorLastName,
    donorEmail,
    referralLink,
    referralAmount,
});
exports.buildPastDueSubscriptionMockData = buildPastDueSubscriptionMockData;
const buildRefundRequestMockData = ({ locale = "en", subject = "Sammy Lee asked for a refund", donorName = "Sammy Lee", formTitle = "Spring Gala 2026", paymentDate = "September 18, 2026", amount = "$25.00", reason = "Can't attend or event canceled", donorMessage = "I'm sorry, I have to travel that week and won't be able to attend.", expiryInDays = 30, paymentUrl = "https://www.zeffy.com/en-US/o/all-payments", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    donorName,
    formTitle,
    paymentDate,
    amount,
    reason,
    donorMessage,
    expiryInDays,
    paymentUrl,
});
exports.buildRefundRequestMockData = buildRefundRequestMockData;
